import { render, staticRenderFns } from "./TaskDetailError.vue?vue&type=template&id=982ef5c8"
import script from "./TaskDetailError.vue?vue&type=script&lang=js"
export * from "./TaskDetailError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports